import StudyLogoPDF from "./StudyLogoPDF";
import { Document, Font, Page, StyleSheet, Text, View } from "@react-pdf/renderer";
import * as React from "react";
import moment from "moment";

import fontRobotoRegular from "../../assets/fonts/Roboto/Roboto-Regular.ttf";
import fontRobotoLight from "../../assets/fonts/Roboto/Roboto-Light.ttf";
import fontRobotoBold from "../../assets/fonts/Roboto/Roboto-Bold.ttf";

Font.register({ family: "RobotoRegular", src: fontRobotoRegular });
Font.register({ family: "RobotoLight", src: fontRobotoLight });
Font.register({ family: "RobotoBold", src: fontRobotoBold });

let newDate = new Date();
let month = newDate.getMonth() + 1;
let year = newDate.getFullYear();
let day = newDate.getDate();

if (month < 10) {
  month = "0" + month;
}

if (day < 10) {
  day = "0" + day;
}
const currentDate = `${day}/${month}/${year}`;

const styles = StyleSheet.create({
  fontRegular: { fontFamily: "RobotoRegular" },
  fontLight: { fontFamily: "RobotoLight" },
  fontBold: { fontFamily: "RobotoBold" },
  body: {
    paddingTop: 35,
    paddingBottom: 80,
    paddingHorizontal: 35,
    fontFamily: "RobotoRegular",
    fontSize: 10,
  },
  headerRight: {
    marginLeft: "50%",
    marginTop: 25,
    marginRight: 40,
    fontSize: 12,
    textAlign: "right",
    lineHeight: 1.5,
    wordBreak: "keep-all",
  },
  headerName: {
    fontSize: 11,
    fontFamily: "RobotoBold",
    wordBreak: "keep-all",
  },
  headerAdress: {
    fontSize: 10,
    fontFamily: "RobotoRegular",
  },
  headerDate: {
    marginTop: 20,
    fontSize: 9.5,
    fontFamily: "RobotoRegular",
  },
  remarque: {
    border: "1px solid grey",
    borderRadius: 3,
    width: "80%",
    marginLeft: "10%",
    fontFamily: "RobotoRegular",
    fontSize: 10,
    marginTop: 25,
    lineHeight: 2,
  },
  remarqueText: {
    marginTop: 8,
    marginLeft: 5,
  },
  ttc: {
    //minHeight: 100,
    overflow: "auto",
    border: "1px solid grey",
    borderRadius: 3,
    width: "80%",
    marginLeft: "10%",
    fontFamily: "RobotoBold",
    fontSize: 14,
    marginTop: 15,
  },
  ttcInternCtn: {
    flexDirection: "column",
  },
  ttcLeft: {
    paddingTop: 10,
    paddingLeft: 15,
    paddingBottom: 10,
    width: "100%",
    borderBottom: "1px solid grey",
    backgroundColor: "rgba(94,145,182,0.8)",
  },
  othersResultsBlock: {
    padding: "10 0 10 15",
    width: "90%",
  },
  othersResults: {
    fontSize: 12,
    paddingTop: 10,
    paddingBottom: 10,
  },
  bodyFooterCtn: {
    width: "80%",
    marginLeft: "10%",
    // marginTop: 175,
    position: "absolute",
    bottom: 15,
    left: 0,
    right: 0,
  },
  bodyFooterBold: {
    fontFamily: "RobotoBold",
    fontSize: 8,
    marginTop: 10,
    textAlign: "justify",
  },
  bodyFooterLight: {
    fontFamily: "RobotoLight",
    fontSize: 6,
    marginTop: 5,
  },
  bodyFooterMapped: {
    fontSize: 8,
    marginTop: 4,
  },
  bodyFooterMappedTitle: {
    fontSize: 8,
    marginTop: 4,
    fontFamily: "RobotoBold",
  },
  rappel: {
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    columnGap: 100,
    width: "80%",
    //height: 120,
    marginLeft: "10%",
    marginTop: 20,
    paddingRight: 20,
    paddingLeft: 20,
  },
  containerTitleSimu: {
    position: "relative",
    marginTop: 20,
    marginRight: "auto",
    marginLeft: "auto",
    width: "75%",
  },
  titleSimu: {
    fontSize: 14,
    textAlign: "center",
    fontFamily: "RobotoBold",
    wordBreak: "keep-all",
  },
  usuTitle: {
    color: "rgba(94,145,182,0.8)",
    fontSize: 13,
    paddingBottom: 5,
  },
  usuTitle2: {
    color: "rgba(94,145,182,0.8)",
    fontSize: 13,
    paddingBottom: 5,
    paddingTop: 15,
  },
  usuResults: {
    fontSize: 12,
    paddingTop: 5,
    paddingBottom: 5,
  },
  personne2TableContainer: {
    border: "1px solid grey",
    borderRadius: 3,
    width: "80%",
    marginLeft: "10%",
    marginTop: 20,
    overflow: "hidden",
  },
  personne2TableHeader: {
    backgroundColor: "rgba(94,145,182,0.8)",
    paddingTop: 10,
    paddingLeft: 15,
    paddingBottom: 10,
    width: "100%",
    borderBottom: "1px solid grey",
  },
  personne2TableContent: {
    padding: "10 0 10 15",
    width: "90%",
  },
  personne1TableContainer: {
    border: "1px solid grey",
    borderRadius: 3,
    width: "80%",
    marginLeft: "10%",
    marginTop: 20,
    overflow: "hidden",
  },
  personne1TableHeader: {
    backgroundColor: "rgba(94,145,182,0.8)",
    paddingTop: 10,
    paddingLeft: 15,
    paddingBottom: 10,
    width: "100%",
    borderBottom: "1px solid grey",
  },
  personne1TableContent: {
    padding: "10 0 10 15",
    width: "90%",
  },
});

const GenerateOthersPdfFile = ({ simulateurObject }) => {
  let remarque = localStorage.getItem("remarque");

  let currUser = JSON.parse(localStorage.getItem("user"));

  let requestSimu = JSON.parse(localStorage.getItem("requestSimu"));

  let nameSimu = localStorage.getItem("nameSimu");

  let result = simulateurObject["results"]["output"];
  const typeUsufruitInput = parseInt(simulateurObject.data.inputs.type_usufruit);
  const isTemporaire = typeUsufruitInput === 1;

  // Collecter les données de Personne 2
  const personne2Data = result?.filter(r => 
    r.key.includes("_2") || r.key === "age_usufruitier_2"
  ) || [];

  // Collecter les données de Personne 1
  const personne1Data = result?.filter(r => 
    (r.key.includes("_1") && r.key !== "type_usufruit") || r.key === "age_usufruitier_1"
  ) || [];

  //console.log(JSON.stringify(result))

  return (
    // <PDFViewer style={{width: "98vw", height: "98vh"}}>
    <Document>
      <Page size="A4" style={styles.body}>
        <View>
          <View style={styles.headerRight}>
            <StudyLogoPDF user={currUser} />
            <Text style={styles.headerName}>{currUser.societe}</Text>
            <Text style={styles.headerAdress}>{currUser.societe_address}</Text>

            <Text style={styles.headerAdress}>{currUser.societe_zip + " " + currUser.societe_town}</Text>

            <Text style={styles.headerDate}>Dossier suivi par : {currUser.firstname + " " + currUser.lastname}</Text>

            <View style={styles.headerDate}>
              <Text>Le : {currentDate}</Text>
            </View>
          </View>
          <View style={styles.containerTitleSimu}>
            <Text style={styles.titleSimu}>{nameSimu}</Text>
          </View>
          <View style={styles.remarque}>
            <Text style={styles.remarqueText}>Remarques : {remarque}</Text>
          </View>

          <View style={styles.ttc}>
            <View style={styles.ttcInternCtn}>
              <Text style={styles.ttcLeft}>Résultat de votre simulation :</Text>

              <View style={styles.othersResultsBlock}>

                {isTemporaire && result?.find(r => r.key === "duree_utilisee") && (
                  <Text style={styles.othersResults}>
                    Durée de l’usufruit : {
                      result.find(r => r.key === "duree_utilisee").value
                    }
                  </Text>
                )}
                {result?.map((object, index) => {
                  // Exclure les données de Personne 1 et 2 du mapping principal SEULEMENT si 2 personnes
                  if ((personne1Data.length > 0 && personne2Data.length > 0) && (result[index].key.includes("_1") || result[index].key.includes("_2") || result[index].key === "age_usufruitier_1" || result[index].key === "age_usufruitier_2")) {
                    return <></>;
                  }
                  if (result[index].key === "plus_value") {
                    return (
                      <Text style={styles.othersResults}>
                        Plus-Value : {parseInt(result[index].value).toLocaleString("en-EN").replace(/,/g, " ")} €
                      </Text>
                    );
                  } else if (result[index].key === "impot_revenu") {
                    return (
                      <Text style={styles.othersResults}>
                        Impôts sur le revenu :{" "}
                        {parseInt(result[index].value).toLocaleString("en-EN").replace(/,/g, " ")}{" "}€
                      </Text>
                    );
                  } else if (result[index].key === "prelevements_sociaux") {
                    return (
                      <Text style={styles.othersResults}>
                        Prélèvements sociaux :{" "}{parseInt(result[index].value).toLocaleString("en-EN").replace(/,/g, " ")}
                        {" "}€
                      </Text>
                    );
                  } else if (result[index].key === "taxe_additionnelle") {
                    return (
                      <Text style={styles.othersResults}>
                        Taxe additionnelle :{" "}{parseInt(result[index].value).toLocaleString("en-EN").replace(/,/g, " ")}{" "}€
                      </Text>
                    );
                  } else if (result[index].key === "total_impots") {
                    return (
                      <Text style={styles.othersResults}>
                        Total Impôts :{" "}{parseInt(result[index].value).toLocaleString("en-EN").replace(/,/g, " ")}{" "}€
                      </Text>
                    );
                  } else if (result[index].key === "montant_mensualites") {
                    return (
                      <Text style={styles.othersResults}>
                        Montant des mensualités :
                        {" "}{parseInt(result[index].value).toLocaleString("en-EN").replace(/,/g, " ")}{" "}€
                      </Text>
                    );
                  } else if (result[index].key === "total_interets") {
                    return (
                      <Text style={styles.othersResults}>
                        Total des intérêts :{" "}{parseInt(result[index].value).toLocaleString("en-EN").replace(/,/g, " ")}{" "}€
                      </Text>
                    );
                  } else if (result[index].key === "Usufruit_1") {
                    return (
                      <Text style={styles.usuResults}>
                        Usufruit :{" "}{parseInt(result[index].value).toLocaleString("en-EN").replace(/,/g, " ")}{" "}€
                      </Text>
                    );
                  } else if (result[index].key === "Nue_propriete_1") {
                    return (
                      <Text style={styles.usuResults}>
                        Nue-Propriété :{" "}{parseInt(result[index].value).toLocaleString("en-EN").replace(/,/g, " ")}{" "}€
                      </Text>
                    );
                  } else if (result[index].key === "Usufruit_2") {
                    return (
                      <Text style={styles.usuResults}>
                        Usufruit :{" "}{parseInt(result[index].value).toLocaleString("en-EN").replace(/,/g, " ")}{" "}€
                      </Text>
                    );
                  } else if (result[index].key === "Nue_propriete_2") {
                    return (
                      <Text style={styles.usuResults}>
                        Nue-Propriété :{" "}{parseInt(result[index].value).toLocaleString("en-EN").replace(/,/g, " ")}{" "}€
                      </Text>
                    );
                  } else if (result[index].key === "charges_total") {
                    return (
                      <>
                        <Text style={styles.othersResults}>
                          Total des charges :{" "}{parseInt(result[index].value).toLocaleString("en-EN").replace(/,/g, " ")}{" "}€
                        </Text>
                        <Text style={styles.othersResults}>
                          Dont :
                        </Text>
                      </>
                      
                    );
                  } else if (result[index].key === "charges_prorata") {
                    return (
                      <Text style={styles.othersResults}>
                        Prorata de charges de copropriété :{" "}{parseInt(result[index].value).toLocaleString("en-EN").replace(/,/g, " ")}{" "}€
                      </Text>
                    );
                  } else if (result[index].key === "fonds_roulement") {
                    return (
                      parseInt(result[index].value) > 0 && (
                        <Text style={styles.othersResults}>
                          Fonds de roulement :{" "}{parseInt(result[index].value).toLocaleString("en-EN").replace(/,/g, " ")}{" "}€
                        </Text>
                      )
                    )
                  } else if (result[index].key === "fond_reserve") {
                    return (
                      parseInt(result[index].value) > 0 && (
                        <Text style={styles.othersResults}>
                          Fonds de réserve :{" "}{parseInt(result[index].value).toLocaleString("en-EN").replace(/,/g, " ")}{" "}€
                        </Text>
                      )
                    )
                  } else if (result[index].key === "fond_travaux") {
                    return (
                      parseInt(result[index].value) > 0 && (
                        <Text style={styles.othersResults}>
                          Fonds de travaux :{" "}{parseInt(result[index].value).toLocaleString("en-EN").replace(/,/g, " ")}{" "}€
                        </Text>
                      )
                    )
                  } else if (result[index].key === "travaux_vote") {
                    return (
                      parseInt(result[index].value) > 0 && (
                        <Text style={styles.othersResults}>
                          Montant des travaux votés :{" "}{parseInt(result[index].value).toLocaleString("en-EN").replace(/,/g, " ")}{" "}€
                        </Text>
                      )
                    )
                  } else if (result[index].key === "depot_garantie") {
                    return (
                      parseInt(result[index].value) > 0 && (
                        <Text style={styles.othersResults}>
                          Montant du dépôt de garantie :{" "}{parseInt(result[index].value).toLocaleString("en-EN").replace(/,/g, " ")}{" "}€
                        </Text>
                      )
                    )
                  } else if (result[index].key === "prorata_loyer") {
                    return (
                      parseInt(result[index].value) > 0 && (
                        <Text style={styles.othersResults}>
                          Montant du prorata de loyers :{" "}{parseInt(result[index].value).toLocaleString("en-EN").replace(/,/g, " ")}{" "}€
                        </Text>
                      )
                    )
                  } else if (result[index].key === "taxe_fonciere") {
                    return (
                      <Text style={styles.othersResults}>
                        Taxe Foncière :{" "}{parseInt(result[index].value).toLocaleString("en-EN").replace(/,/g, " ")}{" "}€
                      </Text>
                    );
                  } else if (result[index].key === "prix_vente") {
                    return (
                      <Text style={styles.othersResults}>
                        Prix de vente :{" "}{parseInt(result[index].value).toLocaleString("en-EN").replace(/,/g, " ")}{" "}€
                      </Text>
                    );
                  } else if (result[index].key === "prix_net") {
                    return (
                      <Text style={styles.othersResults}>
                        Prix net :{" "}{parseInt(result[index].value).toLocaleString("en-EN").replace(/,/g, " ")}{" "}€
                      </Text>
                    );
                  } else if (result[index].key === "honoraires_ht") {
                    return (
                      <Text style={styles.othersResults}>
                        Honoraires HT :{" "}{parseInt(result[index].value).toLocaleString("en-EN").replace(/,/g, " ")}{" "}€
                      </Text>
                    );
                  } else if (result[index].key === "honoraires_ttc") {
                    return (
                      <Text style={styles.othersResults}>
                        Honoraires TTC :{" "}{parseInt(result[index].value).toLocaleString("en-EN").replace(/,/g, " ")}{" "}€
                      </Text>
                    );
                  } else if (result[index].key === "charges_usufructuaires") {
                    return (
                      <Text style={styles.othersResults}>
                        Montant total des charges usufructuaires :{" "}{parseInt(result[index].value).toLocaleString("en-EN").replace(/,/g, " ")}{" "}€
                      </Text>
                    );
                  } else if (result[index].key === "taux_rendement_usufruit") {
                    return (
                      <Text style={styles.othersResults}>
                        Taux de rendement net de charges usufructuaires : {result[index].value}
                      </Text>
                    );
                  } else if (result[index].key === "valeur_usufruit") {
                      return (
                          <Text style={styles.othersResults}>
                              Valeur économique de l'usufruit : {" "}{parseInt(result[index].value).toLocaleString("en-EN").replace(/,/g, " ")}{" "}€
                          </Text>
                      );
                  } else if (result[index].key === "valeur_nue_propriété") {
                      return (
                          <Text style={styles.othersResults}>
                              Valeur économique de la nue-propriété : {" "}{parseInt(result[index].value).toLocaleString("en-EN").replace(/,/g, " ")}{" "}€
                          </Text>
                      );
                  } else if (result[index].key === "valeur_usufruit_actuel") {
                      return (
                          <Text style={styles.othersResults}>
                              Valeur économique de l'usufruit actuel : {" "}{parseInt(result[index].value).toLocaleString("en-EN").replace(/,/g, " ")}{" "}€
                          </Text>
                      );
                  } else if (result[index].key === "valeur_usufruit_successif") {
                      return (
                          <Text style={styles.othersResults}>
                              Valeur économique de l'usufruit successif : {" "}{parseInt(result[index].value).toLocaleString("en-EN").replace(/,/g, " ")}{" "}€
                          </Text>
                      );
                  } else if (result[index].key === "prix_vente_immeuble") {
                      return (
                          <Text style={styles.othersResults}>
                              Valeur en pleine propriété de l'immeuble : {" "}{parseInt(result[index].value).toLocaleString("en-EN").replace(/,/g, " ")}{" "}€
                          </Text>
                      );
                  } else if (result[index].key === "esperance_de_vie_calculee"){
                    return (
                      <Text style={styles.othersResults}>
                        Espérance de vie usufruitier : {result[index].value}
                      </Text>
                    );
                  } else if (result[index].key === "esperance_actuel_calculee"){
                    return (
                      <Text style={styles.othersResults}>
                        Espérance de vie usufruitier actuel : {result[index].value}
                      </Text>
                    );
                  } else if (result[index].key === "esperance_successif_calculee"){
                    return (
                      <Text style={styles.othersResults}>
                        Espérance de vie usufruitier successif : {result[index].value}
                      </Text>
                    );
                  }

                  // Âge usufruitier 1
                  else if (result[index].key === "age_usufruitier_1") {
                    const isTemporaire = requestSimu.inputs["type_usufruit"] === 1;
                      return (
                        <View>
                          {(!isTemporaire && personne2Data.length > 0 && (
                            <Text style={styles.usuTitle}>Personne 1</Text>
                          ))}
                            <Text style={styles.othersResults}>
                              {result[index].name} : {result[index].value}
                            </Text>
                        </View>
                      );
                  }

                  // Durée usufruit à durée fixe
                  else if (result[index].key === "duree_usufruit") {
                      return (
                          <Text style={styles.othersResults}>
                              Durée de l'usufruit à durée fixe : {result[index].value}
                          </Text>
                      );
                  }
                  else if (result[index].key === "valeur_bien_1") {
                      return (
                          <Text style={styles.othersResults}>
                              {result[index].name} : {parseInt(result[index].value).toLocaleString("en-EN").replace(/,/g, " ")} €
                          </Text>
                      );
                  }
                  else if (result[index].key === "taux_usufruit_1") {
                      return (
                          <Text style={styles.othersResults}>
                              {result[index].name} : {result[index].value}
                          </Text>
                      );
                  }
                  else if (result[index].key === "taux_nue_propriete_1") {
                      return (
                          <Text style={styles.othersResults}>
                              {result[index].name} : {result[index].value}
                          </Text>
                      );
                  }
                  else if (result[index].key === "usufruitier_successif") {
                      const isSuccessif = result[index].value === 1;
                      return (
                          <>
                              <Text style={styles.bodyFooterMappedTitle}>Valeur économique des droits démembrés</Text>
                              <Text style={styles.bodyFooterMappedTitle}>
                                  {isSuccessif ? "Cas 2 : Avec usufruitier successif" : "Cas 1 : Sans usufruitier successif"}
                              </Text>
                          </>
                      )
                  }
                  return <></>;
                })}
              </View>
            </View>
          </View>

          {/* TABLEAU DÉDIÉ POUR PERSONNE 1 - SEULEMENT SI 2 PERSONNES */}
          {personne1Data.length > 0 && personne2Data.length > 0 && (
            <View style={styles.personne1TableContainer}>
              <View style={styles.personne1TableHeader}>
                <Text style={{fontFamily: "RobotoBold", fontSize: 13, color: "white"}}>Personne 1</Text>
              </View>
              <View style={styles.personne1TableContent}>
                {personne1Data.map((item, index) => {
                  if (item.key === "age_usufruitier_1") {
                    return (
                      <Text key={index} style={styles.othersResults}>
                        {item.name} : {item.value}
                      </Text>
                    );
                  } else if (item.key === "valeur_bien_1") {
                    return (
                      <Text key={index} style={styles.othersResults}>
                        {item.name} : {parseInt(item.value).toLocaleString("en-EN").replace(/,/g, " ")} €
                      </Text>
                    );
                  } else if (item.key === "taux_usufruit_1") {
                    return (
                      <Text key={index} style={styles.othersResults}>
                        {item.name} : {item.value}
                      </Text>
                    );
                  } else if (item.key === "taux_nue_propriete_1") {
                    return (
                      <Text key={index} style={styles.othersResults}>
                        {item.name} : {item.value}
                      </Text>
                    );
                  } else if (item.key === "Usufruit_1") {
                    return (
                      <Text key={index} style={styles.usuResults}>
                        Usufruit : {parseInt(item.value).toLocaleString("en-EN").replace(/,/g, " ")} €
                      </Text>
                    );
                  } else if (item.key === "Nue_propriete_1") {
                    return (
                      <Text key={index} style={styles.usuResults}>
                        Nue-Propriété : {parseInt(item.value).toLocaleString("en-EN").replace(/,/g, " ")} €
                      </Text>
                    );
                  }
                  return <></>;
                })}
              </View>
            </View>
          )}

          {/* TABLEAU DÉDIÉ POUR PERSONNE 2 - SEULEMENT SI 2 PERSONNES */}
          {personne2Data.length > 0 && personne1Data.length > 0 && (
            <View break>
              <View style={styles.personne2TableContainer}>
                <View style={styles.personne2TableHeader}>
                  <Text style={{fontFamily: "RobotoBold", fontSize: 13, color: "white"}}>Personne 2</Text>
                </View>
                <View style={styles.personne2TableContent}>
                  {personne2Data.map((item, index) => {
                    if (item.key === "age_usufruitier_2") {
                      return (
                        <Text key={index} style={styles.othersResults}>
                          Âge de la personne 2 : {item.value}
                        </Text>
                      );
                    } else if (item.key === "valeur_bien_2") {
                      return (
                        <Text key={index} style={styles.othersResults}>
                          Valeur donnée par la personne 2 : {parseInt(item.value).toLocaleString("en-EN").replace(/,/g, " ")} €
                        </Text>
                      );
                    } else if (item.key === "taux_usufruit_2") {
                      return (
                        <Text key={index} style={styles.othersResults}>
                          Taux de l'usufruit - Personne 2 : {item.value}
                        </Text>
                      );
                    } else if (item.key === "taux_nue_propriete_2") {
                      return (
                        <Text key={index} style={styles.othersResults}>
                          Taux de la nue-propriété - Personne 2 : {item.value}
                        </Text>
                      );
                    } else if (item.key === "Usufruit_2") {
                      return (
                        <Text key={index} style={styles.usuResults}>
                          Usufruit : {parseInt(item.value).toLocaleString("en-EN").replace(/,/g, " ")} €
                        </Text>
                      );
                    } else if (item.key === "Nue_propriete_2") {
                      return (
                        <Text key={index} style={styles.usuResults}>
                          Nue-Propriété : {parseInt(item.value).toLocaleString("en-EN").replace(/,/g, " ")} €
                        </Text>
                      );
                    }
                    return <></>;
                  })}
                </View>
              </View>
            </View>
          )}

          {/* MAP FOR INPUTS*/}

          <View style={styles.rappel} wrap={false} minPresenceAhead={100}>
            <Text style={styles.bodyFooterMappedTitle}>Rappel de votre simulation :</Text>
            {Object.keys(requestSimu?.inputs).map((key) => {
              if (key === "taxe_fonciere") {
                if (requestSimu.inputs[key] > 0) {
                  return (
                    <Text style={styles.bodyFooterMapped}>
                      Montant taxe foncière :{" "}
                      {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                    </Text>
                  );
                }
              } else if (key === "charges_copropriete") {
                if (requestSimu.inputs[key] > 0) {
                  return (
                    <Text style={styles.bodyFooterMapped}>
                      Montant charges de copropriété :{" "}
                      {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                    </Text>
                  );
                }
              } else if (key === "fonds_roulement") {
                if (requestSimu.inputs[key] > 0) {
                  return (
                    <Text style={styles.bodyFooterMapped}>
                      Besoin en fonds de roulement :{" "}
                      {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                    </Text>
                  );
                }
              } else if (key === "fond_reserve") {
                if (requestSimu.inputs[key] !== undefined) {
                  return (
                    <Text style={styles.bodyFooterMapped}>
                      Fonds de réserve :{" "}
                      {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                    </Text>
                  );
                }
              } else if (key === "fond_travaux") {
                if (requestSimu.inputs[key] !== undefined) {
                  return (
                    <Text style={styles.bodyFooterMapped}>
                      Fonds de travaux :{" "}
                      {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                    </Text>
                  );
                }
              } else if (key === "travaux_vote") {
                if (requestSimu.inputs[key] !== undefined) {
                  return (
                    <Text style={styles.bodyFooterMapped}>
                      Montant des travaux votés:{" "}
                      {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                    </Text>
                  );
                }
              } else if (key === "depot_garantie") {
                if (requestSimu.inputs[key] !== undefined) {
                  return (
                    <Text style={styles.bodyFooterMapped}>
                      Montant de dépôt de garantie :{" "}
                      {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                    </Text>
                  );
                }
              } else if (key === "prorata_loyer") {
                if (requestSimu.inputs[key] !== undefined) {
                  return (
                    <Text style={styles.bodyFooterMapped}>
                      Montant du prorata des loyers :{" "}
                      {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                    </Text>
                  );
                }
              } else if (key === "date_vente") {
                const { inputs } = requestSimu;
                const value = inputs[key];
                if (value) {
                  const dateString = moment(value).format("DD/MM/YYYY");
                  return <Text style={styles.bodyFooterMapped}>Date de vente : {dateString}</Text>;
                }
              } else if (key === "nombre_mensualites") {
                if (requestSimu.inputs[key] > 0) {
                  return <Text style={styles.bodyFooterMapped}>Nombre de mensualités : {requestSimu.inputs[key]}</Text>;
                }
              } else if (key === "taux_interet") {
                if (requestSimu.inputs[key] > 0) {
                  return <Text style={styles.bodyFooterMapped}>Taux d'intérêt : {requestSimu.inputs[key]} %</Text>;
                }
              } else if (key === "capital") {
                if (requestSimu.inputs[key] > 0) {
                  return (
                    <Text style={styles.bodyFooterMapped}>
                      Capital emprunté :
                      {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                    </Text>
                  );
                }
              } else if (key === "nombre_donateurs") {
                if (requestSimu.inputs[key] === 1) {
                  return <Text style={styles.bodyFooterMapped}>Nombre personnes : Une personne</Text>;
                } else if (requestSimu.inputs[key] === 0) {
                  return <Text style={styles.bodyFooterMapped}>Nombre Personnes : Deux personnes</Text>;
                }
              } else if (key === "age_usufruitier_1") {
                if (requestSimu.inputs[key] > 0) {
                    const isTemporaire = requestSimu.inputs["type_usufruit"] === 1;
                    return (
                        <Text style={styles.bodyFooterMapped}>
                            {isTemporaire || !personne2Data.length > 0
                                ? "Âge de l'usufruitier actuel (le vendeur): " 
                                : "Âge personne 1 : "
                            }
                            {requestSimu.inputs[key]} ans
                        </Text>
                    );
                }
                
              } else if (key === "age_usufruitier_2") {
                if (requestSimu.inputs[key] > 0) {
                  return <Text style={styles.bodyFooterMapped}>Âge personne 2 : {requestSimu.inputs[key]} ans</Text>;
                }
              } else if (key === "valeur_bien_1") {
                if (requestSimu.inputs[key] > 0) {
                  const isTemporaire = requestSimu.inputs["type_usufruit"] === 1;    
                  return (
                    <Text style={styles.bodyFooterMapped}>
                      {isTemporaire || !personne2Data.length > 0
                        ? "Valeur du bien : " 
                        : "Valeur bien personne 1 : "
                      }
                      {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                    </Text>
                  );
                }
              } else if (key === "valeur_bien_2") {
                if (requestSimu.inputs[key] > 0) {
                  return (
                    <Text style={styles.bodyFooterMapped}>
                      Valeur bien personne 2 :
                      {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                    </Text>
                  );
                }
              } else if (key === "type_usufruit") {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Type d'usufruit : {requestSimu.inputs[key] === 0 ? "Viager" : "À durée fixe"}
                  </Text>
                );
              } else if (key === "duree_usufruit") {
                if (requestSimu.inputs[key] > 0) {
                  return (
                    <Text style={styles.bodyFooterMapped}>
                      Durée de l'usufruit : {requestSimu.inputs[key]} ans
                    </Text>
                  );
                }
              }else if (key === "type_bien") {
                  if (requestSimu.inputs[key] === 1) {
                  return <Text style={styles.bodyFooterMapped}>Type de bien : Maison ou appartement</Text>;
                } else if (requestSimu.inputs[key] === 2) {
                  return <Text style={styles.bodyFooterMapped}>Type de bien : Terrain</Text>;
                } else if (requestSimu.inputs[key] === 3) {
                  return <Text style={styles.bodyFooterMapped}>Type de bien : Terrain avec construction</Text>;
                }
              } else if (key === "prix_vente") {
                if (requestSimu.inputs[key] > 0) {
                  return (
                    <Text style={styles.bodyFooterMapped}>
                      Prix de vente :{" "}
                      {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                    </Text>
                  );
                }
              } else if (key === "frais_vente") {
                if (requestSimu.inputs[key] > 0) {
                  return (
                    <Text style={styles.bodyFooterMapped}>
                      Montant des frais engagés :{" "}
                      {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                    </Text>
                  );
                }
              } else if (key === "prix_acquisition") {
                if (requestSimu.inputs[key] > 0) {
                  return (
                    <Text style={styles.bodyFooterMapped}>
                      Prix d'acquisition :{" "}
                      {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                    </Text>
                  );
                }
              } else if (key === "frais_acquisition") {
                if (requestSimu.inputs[key] > 0) {
                  return (
                    <Text style={styles.bodyFooterMapped}>
                      Montant des frais d'achat :{" "}
                      {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                    </Text>
                  );
                }
              } else if (key === "date_acquisition") {
                const { inputs } = requestSimu;
                const value = inputs[key];
                if (value) {
                  const dateString = moment(value).format("DD/MM/YYYY");
                  return <Text style={styles.bodyFooterMapped}>Date d'acquisition : {dateString}</Text>;
                }
              } else if (key === "montant_travaux") {
                if (requestSimu.inputs[key] > 0) {
                  return (
                    <Text style={styles.bodyFooterMapped}>
                      Montant des travaux :{" "}
                      {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                    </Text>
                  );
                }
              } else if (key === "type_calcul") {
                if (requestSimu.inputs[key] == 0) {
                  return (
                    <Text style={styles.bodyFooterMapped}>Le calcul est : Depuis la base demandée par le vendeur</Text>
                  );
                } else if (requestSimu.inputs[key] == 1) {
                  return (
                    <Text style={styles.bodyFooterMapped}>
                      Le calcul est : Depuis le prix comprenant les honoraires de négociation
                    </Text>
                  );
                }
              } else if (key === "montant_forfait") {
                if (requestSimu.inputs[key] > 0) {
                  return (
                    <Text style={styles.bodyFooterMapped}>
                      Montant forfaitaire minimum :{" "}
                      {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                    </Text>
                  );
                }
              } else if (key === "montant_demande") {
                if (requestSimu.inputs[key] > 0) {
                  return (
                    <Text style={styles.bodyFooterMapped}>
                      Montant demandé par le vendeur (ou prix de vente) :{" "}
                      {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                    </Text>
                  );
                }
              } else if (key === "taux_remuneration") {
                if (requestSimu.inputs[key] > 0) {
                  return (
                    <Text style={styles.bodyFooterMapped}>Rémunération souhaitée: {requestSimu.inputs[key]} %</Text>
                  );
                }
              } else if (key === "prix_vente_immeuble") {
                if (requestSimu.inputs[key] > 0) {
                  return(
                    <Text style={styles.bodyFooterMapped}>
                      Valeur du prix de vente de l'immeuble : {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                    </Text>
                  );
                }
              } else if (key === "valeur_locative_brute") {
                if (requestSimu.inputs[key] > 0) {
                  return(
                    <Text style={styles.bodyFooterMapped}>
                      Valeur locative annuelle brute : {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                    </Text>
                  );
                }
              } else if (key === "travaux_entretient_annuel") {
                if (requestSimu.inputs[key] > 0) {
                  return(
                    <Text style={styles.bodyFooterMapped}>
                      Montant des travaux d'entretien annuel : {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                    </Text>
                  )
                }
              } else if (key === "fraction_fond_travaux_charges") {
                if (requestSimu.inputs[key] === 0) {
                  return(
                    <Text style={styles.bodyFooterMapped}>
                      S'agit-il d'un lot de copropriété ? : Non
                    </Text>
                  )
                } else {
                  return(
                    <>
                      <Text style={styles.bodyFooterMapped}>
                        S'agit-il d'un lot de copropriété ? : Oui
                      </Text>
                      <Text style={styles.bodyFooterMapped}>
                        Fraction du fonds de travaux afférente aux charges usufructuaires : {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                      </Text>
                    </>
                  )
                }
              } else if (key === "taxe_fonciere") {
                if (requestSimu.inputs[key] > 0) {
                  return(
                    <Text style={styles.bodyFooterMapped}>
                      Montant de la taxe foncière : {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                    </Text>
                  )
                }
              } else if (key === "taxe_logement_vacant") {
                if (requestSimu.inputs[key] > 0) {
                  return(
                    <Text style={styles.bodyFooterMapped}>
                      Montant de la taxe logement vacant : {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                    </Text>
                  )
                }
              } else if (key === "usufruitier_successif_esp") {
                if (requestSimu.inputs[key] === 0) {
                  return(
                    <>
                      <Text style={styles.bodyFooterMapped}>
                        Y a-t-il un usufruitier successif : Non
                      </Text>
                      <Text style={styles.bodyFooterMapped}>
                        Genre de l'usufruitier : {parseInt(requestSimu.inputs["genre"])=== 0 ? 'Homme' : 'Femme'}
                      </Text>
                      <Text style={styles.bodyFooterMapped}>
                        Âge de l'usufruitier : {parseInt(requestSimu.inputs["age_usufruitier"]).toLocaleString("en-EN").replace(/,/g, " ") + " ans"}
                      </Text>
                    </>
                  )
                } else if (requestSimu.inputs[key] === 1) {
                  return(
                    <>
                      <Text style={styles.bodyFooterMapped}>
                        Y a-t-il un usufruitier successif : Oui
                      </Text>
                      <Text style={styles.bodyFooterMapped}>
                        Genre de l'usufruitier actuel : {parseInt(requestSimu.inputs["genre_actuel"])=== 0 ? 'Homme' : 'Femme'}
                      </Text>
                      <Text style={styles.bodyFooterMapped}>
                        Âge de l'usufruitier actuel : {parseInt(requestSimu.inputs["age_usufruitier_actuel"]).toLocaleString("en-EN").replace(/,/g, " ") + " ans"}
                      </Text>
                      <Text style={styles.bodyFooterMapped}>
                        Genre de l'usufruitier successif : {parseInt(requestSimu.inputs["genre_successif"])=== 0 ? 'Homme' : 'Femme'}
                      </Text>
                      <Text style={styles.bodyFooterMapped}>
                        Âge de l'usufruitier successif : {parseInt(requestSimu.inputs["age_usufruitier_successif"]).toLocaleString("en-EN").replace(/,/g, " ") + " ans"}
                      </Text>
                    </>
                  )
                }
              } else if (key === "usufruitier_successif") {
                if (requestSimu.inputs[key] === 0) {
                  return(
                    <>
                      <Text style={styles.bodyFooterMapped}>
                        Espérance de vie usufruitier : {requestSimu.inputs["esperance_vie_usufruitier"].toLocaleString("en-EN").replace(/,/g, " ")}
                      </Text>
                    </>
                  )
                } else if (requestSimu.inputs[key] === 1) {
                  return(
                    <>
                      <Text style={styles.bodyFooterMapped}>
                        Espérance de vie usufruitier actuel : {requestSimu.inputs["esperance_vie_usufruit_actuel"].toLocaleString("en-EN").replace(/,/g, " ")}
                      </Text>
                      <Text style={styles.bodyFooterMapped}>
                        Espérance de vie usufruitier successif : {requestSimu.inputs["esperance_vie_usufruit_successif"].toLocaleString("en-EN").replace(/,/g, " ")}
                      </Text>
                    </>
                  )
                }
              }
              return <></>;
            })}
          </View>
        </View>
        <View style={styles.bodyFooterCtn} fixed>
          <Text style={styles.bodyFooterBold}>
            IMPORTANT : Les informations et les résultats présentés ci-dessus sont donnés à titre indicatif et ne
            peuvent en aucun cas constituer un document à caractère contractuel. Les frais indiqués doivent être
            adressés par virement au minimum 48h-72h à l'avance.
          </Text>
          <Text style={styles.bodyFooterLight}>Sources : Editions Langloÿs - Le Barème Rapide® {year}</Text>
        </View>
      </Page>
    </Document>
    // </PDFViewer>
  );
};

export default GenerateOthersPdfFile;
